export const translateChange = (payload) => {
    return dispatch => {
      dispatch({ type: "LANGUAGE_CHANGE", payload: payload });
    }
}
